import React from 'react';
import { useState } from 'react';

import UserLayout from '../../../components/user-layout/UserLayout';
import styles from './faqPage.module.scss';

const FaqPage = () => {
  const [isOpen, setIsOpen] = useState(null);

  const qAndA = [
    {
      id: 1,
      question: 'Question one',
      answer:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
    },
    {
      id: 2,
      question: 'Question two',
      answer:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
    },
    {
      id: 3,
      question: 'Question three',
      answer:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
    },
    {
      id: 4,
      question: 'Question four',
      answer:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
    },
  ];

  const accordionClickHandle = (e, index) => {
    if (index !== null && index === isOpen) {
      setIsOpen(null);
    } else {
      setIsOpen(index);
    }
    e.target.classList.toggle('active');
  };
  return (
    <UserLayout>
      <section className={styles.faqWrapper}>
        <h1 className={styles.faqWrapper_heading}>FAQ</h1>

        <div className={styles.accordion}>
          {qAndA.map((question, index) => (
            <div key={index} className={styles.accordionItem}>
              <div
                className={styles.itemHeader}
                onClick={(e) => {
                  accordionClickHandle(e, index);
                }}
              >
                <h4 className={styles.itemHeader_title}>{question.question}</h4>
                <span className={styles.itemHeader_icon}>+</span>
              </div>
              {isOpen === index ? (
                <div className={styles.accordionBody}>
                  <p
                    className={`${styles.accordionBody_content} ${styles.active}`}
                  >
                    {question.answer}
                  </p>
                </div>
              ) : (
                ''
              )}
            </div>
          ))}
        </div>
      </section>
    </UserLayout>
  );
};

export default FaqPage;
